import React, { useState } from "react";
import styles from "./EnterFather.module.scss";

export default function EnterFather({ fatherName, setFatherName, devider = true }) {
  const [error, setError] = useState("");

  const handleFatherNameChange = (e) => {
    const value = e.target.value;

    // Allow only letters and spaces
    if (!/^[A-Za-z\s]*$/.test(value)) {
      return;
    }

    setFatherName(value);

    // Validation
    const trimmedValue = value.trim();

    if (!trimmedValue) {
      setError("Father's name is required.");
    } else if (trimmedValue.length < 3) {
      setError("Father's name must be at least 2 characters.");
    } else if (trimmedValue.length > 100) {
      setError("Father's name must not exceed 100 characters.");
    } else {
      setError("");
    }
  };

  return (
    <>
      <div className={styles.card}>
        <div className={styles.header}>
          <h3>Father's Name</h3>
          <span className={styles.badge}>Required</span>
        </div>

        <p className={styles.description}>We don't have your father's name in our records.</p>
        <p className={styles.description}>Please provide it to complete your KYC.</p>

        <input type="text" value={fatherName} className={styles.input} onChange={handleFatherNameChange} placeholder="Enter Father's name" maxLength={100} required />

        {error && <p className={styles.error}>{error}</p>}
      </div>

      {devider && (
        <div className={styles.divider}>
          <span className={styles.line}></span>

          <p className={styles.text}>Complete Re-KYC using</p>

          <span className={styles.line}></span>
        </div>
      )}
    </>
  );
}
